<a (click)="fireOptions()">
  <button class="px-4 py-2 btn-grad rounded duration-500">Gerir Ordem das Marcas</button>
</a>